"use strict";

webpackJsonp([1], {

  /***/164:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
    /* WEBPACK VAR INJECTION */(function (global) {
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(79);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(168);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(173);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(195);
      // The Vue build version to load with the `import` command
      // (runtime-only or standalone) has been set in webpack.base.conf with an alias.


      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

      /* eslint-disable no-new */
      new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
        template: '<App/>',
        components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
      });

      function DeviceLink() {
        this.set = function (name) {};
      }

      global.device = new DeviceLink();
      /* WEBPACK VAR INJECTION */
    }).call(__webpack_exports__, __webpack_require__(46));

    /***/
  },

  /***/168:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(171);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11174dce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(172);
    function injectStyle(ssrContext) {
      __webpack_require__(169);
    }
    var normalizeComponent = __webpack_require__(47);
    /* script */

    /* template */

    /* template functional */
    var __vue_template_functional__ = false;
    /* styles */
    var __vue_styles__ = injectStyle;
    /* scopeId */
    var __vue_scopeId__ = null;
    /* moduleIdentifier (server only) */
    var __vue_module_identifier__ = null;
    var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11174dce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);

    /* harmony default export */__webpack_exports__["a"] = Component.exports;

    /***/
  },

  /***/169:
  /***/function _(module, exports) {

    // removed by extract-text-webpack-plugin

    /***/},

  /***/171:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var lastTouch = 0;
    /* harmony default export */__webpack_exports__["a"] = {
      name: 'app',
      data: function data() {
        return {
          menuIpSettings: 'element-hide'
        };
      },

      computed: {
        inProcess: function inProcess() {
          return this.$store.state.inProcess ? 'in-process' : '';
        },
        isLoading: function isLoading() {
          return this.$store.state.isLoading ? '' : 'element-hide';
        }
      },
      methods: {
        showSettings: function showSettings() {
          var now = Date.now();
          if (now - lastTouch > 250) {
            lastTouch = now;
            return;
          }

          this.menuIpSettings = 'settings-show';
          console.log('settings->', this.menuIpSettings);
        },
        hideSettings: function hideSettings() {
          this.menuIpSettings = 'element-hide';
          var ip1 = document.getElementById('ip1').value;
          var ip2 = document.getElementById('ip2').value;
          console.log(ip1, ip2);
          this.$store.commit('setIPs', { ip1: ip1, ip2: ip2 });
        }
      }
    };

    /***/
  },

  /***/172:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    var render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { attrs: { "id": "app" } }, [_c('header', { class: _vm.inProcess, on: { "touchstart": function touchstart($event) {
            _vm.showSettings();
          } } }, [_c('meta', { attrs: { "name": "viewport", "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=false" } }), _vm._v(" "), _c('span', { class: _vm.isLoading }, [_vm._v("loading...")])]), _vm._v(" "), _c('main', [_c('router-view'), _vm._v(" "), _c('div', { class: _vm.menuIpSettings }, [_c('div', { staticClass: "settings-content" }, [_c('div', [_c('label', [_vm._v("IP1:")]), _vm._v(" "), _c('input', { staticClass: "ip", attrs: { "id": "ip1", "type": "text" }, domProps: { "value": _vm.$store.state.ip1 } }), _c('br')]), _vm._v(" "), _c('div', [_c('label', [_vm._v("IP2:")]), _vm._v(" "), _c('input', { staticClass: "ip", attrs: { "id": "ip2", "type": "text" }, domProps: { "value": _vm.$store.state.ip2 } }), _c('br')]), _vm._v(" "), _c('button', { staticClass: "ip", on: { "touchstart": function touchstart($event) {
            _vm.hideSettings();
          } } }, [_vm._v("OK")]), _c('br')])])], 1)]);
    };
    var staticRenderFns = [];
    var esExports = { render: render, staticRenderFns: staticRenderFns
      /* harmony default export */ };__webpack_exports__["a"] = esExports;

    /***/
  },

  /***/173:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(79);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(174);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(175);

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

    /* harmony default export */__webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
      routes: [{
        path: '/',
        name: 'Hello',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
      }]
    });

    /***/
  },

  /***/175:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(177);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58079340_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(194);
    function injectStyle(ssrContext) {
      __webpack_require__(176);
    }
    var normalizeComponent = __webpack_require__(47);
    /* script */

    /* template */

    /* template functional */
    var __vue_template_functional__ = false;
    /* styles */
    var __vue_styles__ = injectStyle;
    /* scopeId */
    var __vue_scopeId__ = null;
    /* moduleIdentifier (server only) */
    var __vue_module_identifier__ = null;
    var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58079340_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);

    /* harmony default export */__webpack_exports__["a"] = Component.exports;

    /***/
  },

  /***/176:
  /***/function _(module, exports) {

    // removed by extract-text-webpack-plugin

    /***/},

  /***/177:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__components_buttonud__ = __webpack_require__(178);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_ladder__ = __webpack_require__(182);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__components_infobox__ = __webpack_require__(186);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__components_preset__ = __webpack_require__(190);
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */__webpack_exports__["a"] = {
      name: 'hello',
      data: function data() {
        return {
          lastClickTime: Date.now()
        };
      },

      components: {
        'buttonud': __WEBPACK_IMPORTED_MODULE_0__components_buttonud__["a" /* default */],
        'ladder': __WEBPACK_IMPORTED_MODULE_1__components_ladder__["a" /* default */],
        'infobox': __WEBPACK_IMPORTED_MODULE_2__components_infobox__["a" /* default */],
        'preset': __WEBPACK_IMPORTED_MODULE_3__components_preset__["a" /* default */]
      },
      methods: {
        reload: function reload() {
          var time = Date.now() - this.lastClickTime;
          if (time < 400) {
            console.log('reload');
            this.$store.dispatch('read');
          }
          this.lastClickTime = Date.now();
        }
      }
    };

    /***/
  },

  /***/178:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buttonud_vue__ = __webpack_require__(180);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb42b1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buttonud_vue__ = __webpack_require__(181);
    function injectStyle(ssrContext) {
      __webpack_require__(179);
    }
    var normalizeComponent = __webpack_require__(47);
    /* script */

    /* template */

    /* template functional */
    var __vue_template_functional__ = false;
    /* styles */
    var __vue_styles__ = injectStyle;
    /* scopeId */
    var __vue_scopeId__ = null;
    /* moduleIdentifier (server only) */
    var __vue_module_identifier__ = null;
    var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buttonud_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb42b1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buttonud_vue__["a" /* default */], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);

    /* harmony default export */__webpack_exports__["a"] = Component.exports;

    /***/
  },

  /***/179:
  /***/function _(module, exports) {

    // removed by extract-text-webpack-plugin

    /***/},

  /***/180:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    /* harmony default export */
    __webpack_exports__["a"] = {
      name: 'buttonud',
      props: ['sensor', 'max'],
      data: function data() {
        return {
          pressId: 0
        };
      },

      computed: {
        temp: function temp() {
          return this.$store.state[this.sensor];
        }
      },
      methods: {
        inc: function inc(curId) {
          if (curId !== this.pressId) {
            return;
          }
          if (this.temp < this.max) {
            this.$store.commit('warmerInc'); // this.temp++
          }
          setTimeout(this.inc, 200, curId);
        },
        dec: function dec(curId) {
          if (curId !== this.pressId) {
            return;
          }
          if (this.temp > 0) {
            this.$store.commit('warmerDec'); // this.temp--
          }
          setTimeout(this.dec, 200, curId);
        }
      }
    };

    /***/
  },

  /***/181:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    var render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "button-container" }, [_c('div', { staticClass: "buttons" }, [_c('div', { staticClass: "button-up", on: { "touchstart": function touchstart($event) {
            _vm.inc(_vm.pressId);
          }, "touchend": function touchend($event) {
            _vm.pressId++;
          } } }), _vm._v(" "), _c('div', { staticClass: "button-down", on: { "touchstart": function touchstart($event) {
            _vm.dec(_vm.pressId);
          }, "touchend": function touchend($event) {
            _vm.pressId++;
          } } })]), _vm._v(" "), _c('div', { staticClass: "button-info" }, [_vm._v("\n    " + _vm._s(_vm.temp) + "\n  ")])]);
    };
    var staticRenderFns = [];
    var esExports = { render: render, staticRenderFns: staticRenderFns
      /* harmony default export */ };__webpack_exports__["a"] = esExports;

    /***/
  },

  /***/182:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ladder_vue__ = __webpack_require__(184);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f975e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ladder_vue__ = __webpack_require__(185);
    function injectStyle(ssrContext) {
      __webpack_require__(183);
    }
    var normalizeComponent = __webpack_require__(47);
    /* script */

    /* template */

    /* template functional */
    var __vue_template_functional__ = false;
    /* styles */
    var __vue_styles__ = injectStyle;
    /* scopeId */
    var __vue_scopeId__ = null;
    /* moduleIdentifier (server only) */
    var __vue_module_identifier__ = null;
    var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ladder_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f975e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ladder_vue__["a" /* default */], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);

    /* harmony default export */__webpack_exports__["a"] = Component.exports;

    /***/
  },

  /***/183:
  /***/function _(module, exports) {

    // removed by extract-text-webpack-plugin

    /***/},

  /***/184:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    /* harmony default export */
    __webpack_exports__["a"] = {
      name: 'ladderud',
      props: ['sensor'],
      data: function data() {
        return {
          pressId: 0,
          max: 10
        };
      },

      computed: {
        value: function value() {
          return this.$store.state[this.sensor];
        },
        blink: function blink() {
          var _this = this;

          var isOn = this.$store.state.presetBlink;
          if (isOn) {
            setTimeout(function () {
              _this.$store.commit('presetBlinkOff');
            }, 200);
          }
          return isOn;
        }
      },
      methods: {
        inc: function inc(curId) {
          if (curId !== this.pressId) {
            return;
          }
          if (this.value < this.max) {
            this.$store.commit('fanInc', this.sensor); // this.value++
          }
          setTimeout(this.inc, 200, curId);
        },
        dec: function dec(curId) {
          if (curId !== this.pressId) {
            return;
          }
          if (this.value > 0) {
            this.$store.commit('fanDec', this.sensor); // this.value--
          }
          setTimeout(this.dec, 200, curId);
        },
        style: function style(n) {
          if (this.blink) {
            return 'line line-preset';
          }
          if (n <= this.value) {
            return 'line line-on';
          }
          return 'line';
        }
      }
    };

    /***/
  },

  /***/185:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    var render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "ladder-container" }, [_c('div', { staticClass: "ladders" }, [_c('div', { staticClass: "ladder-up", on: { "touchstart": function touchstart($event) {
            _vm.inc(_vm.pressId);
          }, "touchend": function touchend($event) {
            _vm.pressId++;
          } } }), _vm._v(" "), _c('div', { staticClass: "ladder-down", on: { "touchstart": function touchstart($event) {
            _vm.dec(_vm.pressId);
          }, "touchend": function touchend($event) {
            _vm.pressId++;
          } } })]), _vm._v(" "), _c('div', { staticClass: "ladder-info" }, [_c('div', { class: _vm.style(10) }), _vm._v(" "), _c('div', { class: _vm.style(9) }), _vm._v(" "), _c('div', { class: _vm.style(8) }), _vm._v(" "), _c('div', { class: _vm.style(7) }), _vm._v(" "), _c('div', { class: _vm.style(6) }), _vm._v(" "), _c('div', { class: _vm.style(5) }), _vm._v(" "), _c('div', { class: _vm.style(4) }), _vm._v(" "), _c('div', { class: _vm.style(3) }), _vm._v(" "), _c('div', { class: _vm.style(2) }), _vm._v(" "), _c('div', { class: _vm.style(1) })])]);
    };
    var staticRenderFns = [];
    var esExports = { render: render, staticRenderFns: staticRenderFns
      /* harmony default export */ };__webpack_exports__["a"] = esExports;

    /***/
  },

  /***/186:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_infobox_vue__ = __webpack_require__(188);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1913c1a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_infobox_vue__ = __webpack_require__(189);
    function injectStyle(ssrContext) {
      __webpack_require__(187);
    }
    var normalizeComponent = __webpack_require__(47);
    /* script */

    /* template */

    /* template functional */
    var __vue_template_functional__ = false;
    /* styles */
    var __vue_styles__ = injectStyle;
    /* scopeId */
    var __vue_scopeId__ = null;
    /* moduleIdentifier (server only) */
    var __vue_module_identifier__ = null;
    var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_infobox_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1913c1a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_infobox_vue__["a" /* default */], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);

    /* harmony default export */__webpack_exports__["a"] = Component.exports;

    /***/
  },

  /***/187:
  /***/function _(module, exports) {

    // removed by extract-text-webpack-plugin

    /***/},

  /***/188:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    //
    //
    //
    //
    //
    //
    //
    //

    /* harmony default export */
    __webpack_exports__["a"] = {
      name: 'infobox',
      props: ['sensor', 'w', 'h', 'fs'],
      computed: {
        temp: function temp() {
          return this.$store.state[this.sensor];
        }
      }
    };

    /***/
  },

  /***/189:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    var render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "info-container", style: { width: _vm.w, height: _vm.h, 'line-height': _vm.h } }, [_c('div', { staticClass: "info-info", style: { 'font-size': _vm.fs } }, [_vm._v("\n    " + _vm._s(_vm.temp) + "\n  ")])]);
    };
    var staticRenderFns = [];
    var esExports = { render: render, staticRenderFns: staticRenderFns
      /* harmony default export */ };__webpack_exports__["a"] = esExports;

    /***/
  },

  /***/190:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preset_vue__ = __webpack_require__(192);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6048d9b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preset_vue__ = __webpack_require__(193);
    function injectStyle(ssrContext) {
      __webpack_require__(191);
    }
    var normalizeComponent = __webpack_require__(47);
    /* script */

    /* template */

    /* template functional */
    var __vue_template_functional__ = false;
    /* styles */
    var __vue_styles__ = injectStyle;
    /* scopeId */
    var __vue_scopeId__ = null;
    /* moduleIdentifier (server only) */
    var __vue_module_identifier__ = null;
    var Component = normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preset_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6048d9b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preset_vue__["a" /* default */], __vue_template_functional__, __vue_styles__, __vue_scopeId__, __vue_module_identifier__);

    /* harmony default export */__webpack_exports__["a"] = Component.exports;

    /***/
  },

  /***/191:
  /***/function _(module, exports) {

    // removed by extract-text-webpack-plugin

    /***/},

  /***/192:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    //
    //
    //
    //
    //
    //
    //
    //

    /* harmony default export */
    __webpack_exports__["a"] = {
      name: 'preset',
      props: ['name', 'dataKey', 'w', 'h', 'fs'],
      data: function data() {
        return {
          timerId: 0
        };
      },

      methods: {
        press: function press(end) {
          var _this = this;

          if (end) {
            if (this.timerId) {
              clearTimeout(this.timerId);
              this.timerId = undefined;
              this.$store.commit('onPresetKey', this.dataKey);
            }
            return;
          }

          if (this.timerId) {
            clearTimeout(this.timerId);
          }
          this.timerId = setTimeout(function () {
            _this.timerId = undefined;
            _this.$store.commit('toPreset', _this.dataKey);
            _this.$store.commit('presetBlinkOn');
            setTimeout(function () {
              _this.$store.commit('presetBlinkOff');
            }, 200);
          }, 1500);
        }
      }
    };

    /***/
  },

  /***/193:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    var render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "preset-container", style: { width: _vm.w, height: _vm.h, 'line-height': _vm.h }, on: { "touchstart": function touchstart($event) {
            _vm.press();
          }, "touchend": function touchend($event) {
            _vm.press(true);
          } } }, [_c('div', { staticClass: "preset-info", style: { 'font-size': _vm.fs } }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")])]);
    };
    var staticRenderFns = [];
    var esExports = { render: render, staticRenderFns: staticRenderFns
      /* harmony default export */ };__webpack_exports__["a"] = esExports;

    /***/
  },

  /***/194:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    var render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "hello" }, [_c('div', { staticClass: "row infoline" }, [_c('ladder', { attrs: { "sensor": "fan0" } }), _vm._v(" "), _c('buttonud', { attrs: { "sensor": "tempWarmer", "max": "30" } }), _vm._v(" "), _c('ladder', { attrs: { "sensor": "fan1" } })], 1), _vm._v(" "), _c('div', { staticClass: "row infoline" }, [_c('infobox', { attrs: { "w": "80px", "h": "44px", "sensor": "tempIn" } }), _vm._v(" "), _c('infobox', { attrs: { "w": "80px", "h": "44px", "sensor": "ssr1" } }), _vm._v(" "), _c('infobox', { attrs: { "w": "80px", "h": "44px", "sensor": "ssr2" } }), _vm._v(" "), _c('infobox', { attrs: { "w": "80px", "h": "44px", "sensor": "tempOut" } })], 1), _vm._v(" "), _c('div', { staticClass: "row infoline" }, [_c('infobox', { attrs: { "w": "105px", "h": "60px", "fs": "30px", "sensor": "outT" } }), _vm._v(" "), _c('infobox', { attrs: { "w": "130px", "h": "60px", "fs": "30px", "sensor": "outP" } }), _vm._v(" "), _c('infobox', { attrs: { "w": "95px", "h": "60px", "fs": "30px", "sensor": "outH" } })], 1), _vm._v(" "), _c('div', { staticClass: "row infoline" }, [_c('infobox', { attrs: { "w": "350px", "h": "70px", "fs": "50px", "sensor": "date" } })], 1), _vm._v(" "), _c('div', { staticClass: "row infoline", on: { "click": _vm.reload } }, [_c('infobox', { attrs: { "w": "350px", "h": "80px", "fs": "70px", "sensor": "time" } })], 1), _vm._v(" "), _c('div', { staticClass: "row infoline" }, [_c('preset', { attrs: { "dataKey": "preset1", "name": "L" } }), _vm._v(" "), _c('preset', { attrs: { "dataKey": "preset2", "name": "N" } }), _vm._v(" "), _c('preset', { attrs: { "dataKey": "preset3", "name": "H" } })], 1)]);
    };
    var staticRenderFns = [];
    var esExports = { render: render, staticRenderFns: staticRenderFns
      /* harmony default export */ };__webpack_exports__["a"] = esExports;

    /***/
  },

  /***/195:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* WEBPACK VAR INJECTION */
    (function (global) {
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(196);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(220);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(235);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(79);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(237);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill__ = __webpack_require__(238);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_polyfill__);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_6_fetch_polyfill__ = __webpack_require__(440);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_6_fetch_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fetch_polyfill__);

      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

      var power = [[0, 0], // 0
      [40, 210], // 0.16
      [40, 160], // 0.2
      [60, 140], // 0.3
      [80, 120], // 0.4
      [80, 80], // 0.5
      [120, 80], // 0.6
      [140, 60], // 0.7
      [160, 40], // 0.8
      [210, 40], // 0.84
      [100, 0] // 1
      ];

      // let ip1, ip2
      try {
        var _JSON$parse = JSON.parse(localStorage.getItem('serverIPs')),
            ip1 = _JSON$parse.ip1,
            ip2 = _JSON$parse.ip2;
      } catch (e) {
        ip1 = '192.168.0.177';
        ip2 = '192.168.0.209';
      }

      var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
        state: {
          count: 0,
          tempWarmer: 0,
          fan0: 0,
          fan1: 0,
          tempIn: 0,
          ssr1: 0,
          ssr2: 0,
          tempOut: 0,
          outH: '',
          outP: '',
          outT: '',
          time: getTime(),
          date: getDate(),
          preset1: loadPresets(0),
          preset2: loadPresets(1),
          preset3: loadPresets(2),
          presetBlink: false,
          ip1: ip1,
          ip2: ip2,
          inProcess: false,
          isLoading: false
        },
        mutations: {
          warmerInc: function warmerInc(state) {
            state.tempWarmer++;
            updateWarmerTemp(state.ip1, state.tempWarmer);
          },
          warmerDec: function warmerDec(state) {
            state.tempWarmer--;
            updateWarmerTemp(state.ip1, state.tempWarmer);
          },
          warmerSet: function warmerSet(state, p) {
            state.tempWarmer = Math.floor(p[0].target_t);
          },
          fanSet: function fanSet(state, p) {
            state.fan0 = p[0];
            state.fan1 = p[1];
          },
          fanInc: function fanInc(state, id) {
            state[id]++;
            updateFanSpeed(state.ip1, id, state[id]);
          },
          fanDec: function fanDec(state, id) {
            state[id]--;
            updateFanSpeed(state.ip1, id, state[id]);
          },
          tempSet: function tempSet(state, p) {
            state.tempOut = Math.round(p[0].t);
            state.ssr1 = Math.round(p[1].t);
            state.ssr2 = Math.round(p[2].t);
            state.tempIn = Math.round(p[3].t);
          },
          outdoorSet: function outdoorSet(state, p) {
            state.outH = Math.round(p.temp.h) + '%';
            state.outT = (p.temp.t > 0 ? '+' : '') + Math.round(p.temp.t) + '°C';
            state.outP = Math.round(p.baro.p) + 'mm';
          },
          updateTime: function updateTime(state) {
            state.time = getTime();
            state.date = getDate();
          },
          onPresetKey: function onPresetKey(state, dataKey) {
            console.log('load preset');
            var d = state[dataKey];
            state.fan0 = d.fan0;
            state.fan1 = d.fan1;
            state.tempWarmer = d.tempWarmer;
            updateWarmerTemp(state.ip1, state.tempWarmer);
            updateFanSpeed(state.ip1, 'fan0', state.fan0);
            updateFanSpeed(state.ip1, 'fan1', state.fan1);
          },
          toPreset: function toPreset(state, dataKey) {
            console.log('store preset');
            var d = state[dataKey];
            d.fan0 = state.fan0;
            d.fan1 = state.fan1;
            d.tempWarmer = state.tempWarmer;
            storePresets(state);
          },
          presetBlinkOn: function presetBlinkOn(state) {
            store.state.presetBlink = true;
          },
          presetBlinkOff: function presetBlinkOff(state) {
            store.state.presetBlink = false;
          },
          setIPs: function setIPs(state, p) {
            store.state.ip1 = p.ip1;
            store.state.ip2 = p.ip2;
            localStorage.setItem('serverIPs', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(p));
          },
          setInPorcess: function setInPorcess(state, value) {
            store.state.inProcess = value;
          },
          setIsLoading: function setIsLoading(state, value) {
            store.state.isLoading = value;
          }
        },
        actions: {
          read: function read(_ref) {
            var state = _ref.state,
                commit = _ref.commit;

            store.commit('setIsLoading', true);
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([fetch('http://' + state.ip1 + '/').then(function (r) {
              r.text().then(function (raw) {
                // hack to compensate hardware minus temperature representation error
                // remove after updating arduino firmware
                var r = JSON.parse(raw.replace(/-\d\.-\d/g, function (a) {
                  return a.replace(/-/g, '');
                }));
                var fans = r.filter(function (e) {
                  return e.type === 'fan';
                }).map(getPowerLevel);
                var warmer = r.filter(function (e) {
                  return e.type === 'warmer';
                });
                var temps = r.filter(function (e) {
                  return e.type === 't_sensor';
                });

                commit('warmerSet', warmer);
                commit('fanSet', fans);
                commit('tempSet', temps);
              }).catch(function (err) {
                console.log('parsing error 1', err);
              });
            }), fetch('http://' + state.ip2 + '/').then(function (r) {
              r.json().then(function (r) {
                var temp = r.filter(function (e) {
                  return e.type === 't_sensor22';
                });
                var baro = r.filter(function (e) {
                  return e.type === 'barometr';
                });

                commit('outdoorSet', { temp: temp[0], baro: baro[0] });
              }).catch(function (err) {
                console.log('parsing error 2', err);
              });
            })]).catch(function (err) {
              console.log('fetch err', err);
            }).then(function () {
              store.commit('setIsLoading', false);
            });
          }
        }
      });
      global.store = store;

      function getTime() {
        return new Date().toTimeString().slice(0, 5);
      }
      function getDate() {
        return new Date().toDateString().slice(4, 10);
      }

      function getPowerLevel(a) {
        for (var i = 0; i < power.length; i++) {
          if (power[i][0] === a.on && power[i][1] === a.off) {
            return i;
          }
        }
        return -1;
      }

      function storePresets(state) {
        var preset1 = state.preset1,
            preset2 = state.preset2,
            preset3 = state.preset3;

        localStorage.setItem('presets', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()([preset1, preset2, preset3]));
      }

      function loadPresets(id) {
        var obj = localStorage.getItem('presets');
        if (!obj) {
          return {
            fan0: 5,
            fan1: 5,
            tempWarmer: 20
          };
        }
        var presets = JSON.parse(obj);
        return presets[id];
      }

      var requestQueue = [];

      function updateFanSpeed(ip1, keyId, level) {
        var _power$level = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(power[level], 2),
            on = _power$level[0],
            off = _power$level[1];

        var id = Number(keyId[keyId.length - 1]);
        // console.log(on, off, id)

        requestQueue = requestQueue.filter(function (e) {
          return e.type !== keyId;
        });
        requestQueue.push({
          type: keyId,
          url: 'http://' + ip1 + '/fan?id=' + id + '&on=' + on + '&off=' + off
        });
        serveRequests();
      }

      function updateWarmerTemp(ip1, value) {
        requestQueue = requestQueue.filter(function (e) {
          return e.type !== 'temp';
        });
        requestQueue.push({
          type: 'temp',
          url: 'http://' + ip1 + '/warmer?temp=' + value
        });
        serveRequests();
      }

      function serveRequests() {
        if (store.state.inProcess) {
          return;
        }
        store.commit('setInPorcess', true);

        var routine = function routine() {
          var task = requestQueue.pop();
          console.log('=> ' + task.url);

          fetch(task.url).then(function (r) {
            if (!r.ok) {
              requestQueue.unshift(task);
            }
          }).catch(function (e) {
            requestQueue.unshift(task);
          }).finally(function () {
            if (requestQueue.length) {
              setTimeout(routine, 500);
            } else {
              store.commit('setInPorcess', false);
            }
          });
        };

        setTimeout(routine, 0);
      }

      /* harmony default export */__webpack_exports__["a"] = store;

      store.dispatch('read');
      store.commit('updateTime');

      /* disable autorefresh to lower device energy consumption
      let lastTimeUpdate = 0
      function checkUpdate () {
        let now = Date.now()
        if (now - lastTimeUpdate > 60000) {
          lastTimeUpdate = now
          store.dispatch('read')
          store.commit('updateTime')
        }
      }
      let updateId = setInterval(checkUpdate, 1000)
      checkUpdate()
      
      function handleVisibilityChange () {
        clearInterval(updateId) // disable updates on page background
        if (document.webkitHidden) {
          lastTimeUpdate = 0 // force reload on next page open
        } else {
          updateId = setInterval(checkUpdate, 1000)
        }
      }
      
      document.addEventListener('webkitvisibilitychange', handleVisibilityChange, false)
      */
      /* WEBPACK VAR INJECTION */
    }).call(__webpack_exports__, __webpack_require__(46));

    /***/
  }

}, [164]);


// WEBPACK FOOTER //
// static/js/app.29ce4f41aa735af6c525.js